import {initYandexMap} from "./initYandexMap";
import {API_MAP_KEY, MAPS} from "./constants";

const SCRIPT = document.createElement( `script` );
SCRIPT.src = API_MAP_KEY;

const YmapsAttribute = {
	LOAD: `data-ymaps-api-load`,
	UPLOAD: `data-ymaps-api-upload`,
};

const MAP_REQUIRED_CLASS = 'required';

const isYmapsLoad = () => {
	return !!document.body.getAttribute( YmapsAttribute.LOAD );
};

const isYmapsUpload = () => {
	return !!document.body.getAttribute( YmapsAttribute.UPLOAD );
};

const applyYmapsApi = () => {
	document.body.setAttribute( YmapsAttribute.UPLOAD, true );
	
	MAPS.forEach( initYandexMap );
};

const loadYandexApiScript = () => {
	if ( !isYmapsLoad() )
	{
		document.body.appendChild( SCRIPT );
		
		document.body.setAttribute( YmapsAttribute.LOAD, true );
		
		SCRIPT.addEventListener(`load`, () => {
			ymaps.ready( applyYmapsApi );
		});
	}
	else if ( ymaps )
	{
		ymaps.ready( applyYmapsApi );
	}
	else
	{
		SCRIPT.addEventListener(`load`, () => {
			ymaps.ready( applyYmapsApi );
		});
	}
};

const initMapContainer = ( mapContainer ) => {
	if ( isYmapsLoad() && ymaps )
	{
		ymaps.ready( () => {
			initYandexMap( mapContainer );
		} );
	}
	
	loadYandexApiScript();
};

const initDivMap = () => {
	const mapContainer = document.querySelector( `div.map` );
	
	if ( mapContainer )
	{
		if ( mapContainer.classList.contains( `defer` ) )
		{
			setTimeout( loadYandexApiScript, 5000 );
		}
		else if ( !mapContainer.classList.contains( MAP_REQUIRED_CLASS ) )
		{
			loadYandexApiScript();
		}
	}
};

export {
	MAP_REQUIRED_CLASS,
	initDivMap,
	initMapContainer,
}
